module.exports = __webpack_public_path__ + "img/doctors-avatar-placeholder.050abf73.svg";